// ── 연차 관리 상수 ─────────────────────────────────────────────────────────────

export const PAGE_SIZE = 10;
export const MOBILE_BREAKPOINT = 768;

// 단건 입력/수정에서 선택 가능한 연차 종류
// '반차'는 구형 데이터용으로 수정 폼에서만 허용, 신규 입력은 '반차(전)'/'반차(후)' 사용
export const LEAVE_TYPES_FORM = ['연차', '반차(전)', '반차(후)', '경조사', '정산', '포상', '생성', '정정'];
// 수정 폼에서는 '반차'(구형)도 허용 (기존 레코드 수정 시 타입 유지)
export const LEAVE_TYPES_FORM_EDIT = ['연차', '반차', '반차(전)', '반차(후)', '경조사', '정산', '포상', '생성', '정정'];
// 대량 붙여넣기 검증용 목록 (기존 데이터 호환을 위해 '반차'/'자동생성'도 허용)
export const LEAVE_TYPES_BULK = ['연차', '반차', '반차(전)', '반차(후)', '경조사', '정산', '포상', '생성', '정정', '자동생성'];
// 구분 목록
export const LEAVE_CATEGORIES = ['유급', '무급', '경조사', '정산', '포상', '생성', '정정'];

// 특정 종류는 구분이 자동 고정됨
export const TYPE_TO_LOCKED_CATEGORY = {
  경조사: '경조사', 정산: '정산', 포상: '포상', 생성: '생성', 정정: '정정',
};
// 연차/반차 계열은 유급/무급만 선택 가능
export const TYPE_WITH_PAID_UNPAID_ONLY = new Set(['연차', '반차', '반차(전)', '반차(후)']);
export const PAID_UNPAID_CATEGORIES = ['유급', '무급'];

// 종류별 고정 개수 — 해당 종류 선택 시 개수 입력 불가, 자동 고정
export const FIXED_COUNT_MAP = { 연차: '1', 반차: '0.5', '반차(전)': '0.5', '반차(후)': '0.5', 경조사: '1' };

// 반차기준시간이 필요한 종류 (미설정 시 경고 표시)
export const HALF_LEAVE_TYPES = new Set(['반차(전)', '반차(후)']);

export const PAYROLL_EFFECT_OPTIONS = [
  { value: 'paid_cover', label: '유급 인정' },
  { value: 'unpaid_absence', label: '무급 공제' },
  { value: 'none', label: '급여 영향 없음' },
];

export const BALANCE_EFFECT_OPTIONS = [
  { value: 'deduct', label: '잔여연차 차감' },
  { value: 'grant', label: '연차 발생' },
  { value: 'settlement', label: '정산 차감' },
  { value: 'none', label: '잔여연차 반영 안 함' },
];

export const MONTHLY_GRANT_EFFECT_OPTIONS = [
  { value: 'neutral', label: '월차 발생 영향 없음' },
  { value: 'blocks', label: '월차 발생 영향 있음' },
];

export const CALENDAR_EFFECT_OPTIONS = [
  { value: 'full_day', label: '달력 전일 표시' },
  { value: 'half_am', label: '달력 오전반차' },
  { value: 'half_pm', label: '달력 오후반차' },
  { value: 'none', label: '달력 표시 안 함' },
];

// 주휴수당 영향: 무급 공제·급여 영향 없음일 때 노출(2026-10-01 — 예전엔 무급만, payrollEffectRules.js).
//   회사 지정 무급휴가(여름휴가 등)는 '영향 없음'으로 주휴 유지. '급여 영향 없음'을 고르면 자동으로 '영향 없음'.
export const WEEKLY_HOLIDAY_EFFECT_OPTIONS = [
  { value: 'affects', label: '주휴수당 공제 대상' },
  { value: 'none', label: '주휴수당 영향 없음' },
];

// 스프레드시트 대량 붙여넣기 컬럼 정의
export const BULK_COLUMNS = [
  { key: 'date',     label: '연차사용일', required: true,  placeholder: '2026-03-06' },
  { key: 'name',     label: '성명',      required: true,  placeholder: '홍길동' },
  { key: 'type',     label: '종류',      required: true,  placeholder: '연차' },
  { key: 'category', label: '구분',      required: true,  placeholder: '유급' },
  { key: 'count',    label: '개수',      required: true,  placeholder: '1 또는 0.5' },
  { key: 'reason',   label: '사유',      required: false, placeholder: '사유' },
];

// 종류별 뱃지 배경/글자색 — 배경은 rgba 15%로 라이트/다크 자동 대응, 글자 색은 진한 톤 유지
export const TYPE_BADGE = {
  연차:       { bg: 'rgba(147,51,234,0.15)', color: '#5b21b6' },
  반차:       { bg: 'rgba(168,85,247,0.15)', color: '#7e22ce' },
  '반차(전)': { bg: 'rgba(168,85,247,0.15)', color: '#7e22ce' },
  '반차(후)': { bg: 'rgba(168,85,247,0.15)', color: '#7e22ce' },
  경조사:   { bg: 'rgba(236,72,153,0.15)', color: '#be185d' },
  정산:     { bg: 'rgba(14,165,233,0.15)', color: '#0369a1' },
  포상:     { bg: 'rgba(34,197,94,0.15)',  color: '#166534' },
  생성:     { bg: 'rgba(29,78,216,0.15)',  color: '#1d4ed8' },
  자동생성: { bg: 'rgba(29,78,216,0.15)',  color: '#1d4ed8' },
  유급인정: { bg: 'rgba(37,99,235,0.15)',  color: '#1d4ed8' },
  정정:     { bg: 'var(--bg-subtle)',       color: 'var(--text-sub)' },
};

// 구분별 뱃지 배경/글자색 — 동일 rgba 톤
export const CATEGORY_BADGE = {
  유급:   { bg: 'rgba(34,197,94,0.15)',  color: '#166534' },
  무급:   { bg: 'rgba(239,68,68,0.15)',  color: '#991b1b' },
  경조사: { bg: 'rgba(236,72,153,0.15)', color: '#be185d' },
  정산:   { bg: 'rgba(14,165,233,0.15)', color: '#0369a1' },
  포상:   { bg: 'rgba(34,197,94,0.15)',  color: '#166534' },
  생성:   { bg: 'rgba(29,78,216,0.15)',  color: '#1d4ed8' },
  정정:   { bg: 'var(--bg-subtle)',      color: 'var(--text-sub)' },
};
